import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/Layout';
import Meta from '../components/Meta';
import Intro from '../components/Intro';
import Faq from '../components/Faq';
import ModalEditPdf from '../components/ModalEditPdf';
import useEditorStore from '../store/useEditorStore';
import HomeHowTo from "../components/HomeHowTo";
import Why from "../components/Why";
import GridEditSign from "../components/gridElements/GridEditSign";
import GridConvertPdf from "../components/gridElements/GridConvertPdf";
import GridConvertToPdf from "../components/gridElements/GridConvertToPdf";
import GridEditPdf from "../components/gridElements/GridEditPdf";

const PageIndex = () => {
  const { t } = useTranslation(['common', 'index', 'edit-pdf']);
  const isReady = useEditorStore.use.isReady()

  const meta = (
    <Meta
      title={t('index:meta.title')}
      description={t('index:meta.description')}
    />
  );

  const intro = (
    <Intro
      title={t('index:intro.title')}
      text={t('index:intro.text')}
    />
  );

  const howto = <HomeHowTo howto={t('index:howto', { returnObjects: true })}/>;

  const faq = <Faq items={t('index:faq.items', { returnObjects: true })} />;

  const why = <Why />;

  return (
    <Layout className="page-index">
      {!isReady && <>
        {meta}
        {intro}
      </>}
      <ModalEditPdf />
      {!isReady && <>
        <div className="grid_background">
          <GridEditSign/>
          <GridConvertPdf/>
          <GridConvertToPdf/>
          <GridEditPdf/>
        </div>
        {howto}
        {why}
        {faq}
      </>}
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'index', 'convert-and-edit', 'edit-pdf'])),
  },
});

export default PageIndex;
